import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'capitalizeFirst'
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string, originial?): string {
    if (!value) return '';
    value = value.trim();

    // Capitalize first letter of the first word
    let transformed = value.charAt(0).toUpperCase() + value.slice(1);

    // Ensure it ends with a period
    if (!originial) {
      if (!/[.!?]$/.test(transformed)) {
        transformed += '.';
      }
    }

    return transformed;
  }
}
